import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

export const Route = createFileRoute('/_app/declarations/')({
  component: DeclarationsPage,
})

function DeclarationsPage(): JSX.Element {
  return <div>Declaraciones — placeholder</div>
}
